import { Button, Col, Row } from "antd";
import styles from "./FrontendPage.module.scss";
import mockupGadgets from "./../../assets/images/mockupGadgets.jpg";
import frontendDashboard from "./../../assets/images/frontendDashboard.jpg";
import { useSize } from "ahooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function FrontendDevelopment() {
  const { t } = useTranslation();
  const size = useSize(document.querySelector("body"));
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div className={styles.pageWrapper}>
        <Row
          className={styles.descWrapper}
          align="middle"
          justify={size?.width! >= 768 ? "space-around" : "start"}
        >
          <Col xs={21} sm={21} md={12} lg={12} xl={12}>
            <div className={styles.columnTitle}>{t("Frontend.headTitle")}</div>
            <p className={styles.developmentText}>
              {t("Frontend.headDescription")}
            </p>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={10}
            lg={9}
            xl={8}
            className={styles.stackBox}
          >
            {" "}
            <div className={styles.stackTitle}>{t("Frontend.headTitle")}</div>
            <h5 className={styles.stackStack}>{t("Frontend.stack")}</h5>
            <div className={styles.stackText}>
              Java Script / Type Script, HTML, CSS, SASS, SCSS, React, React
              Router, React Native, JQuery, Three.js (3d graphic), Vue.js,
              Nuxt.js, Redux, MobX, Tailwind, Vuex, Vite, DaisyUI, GraphQL
            </div>
            <Row justify="start" className={styles.stackRow}>
              {" "}
              <Button
                onClick={() =>
                  navigate({
                    pathname: "/portfolio"
                  })
                }
                className={styles.projectsBtn}
              >
                {t("portfolio.projects")}
              </Button>{" "}
              <Button
                onClick={() =>
                  navigate({
                    pathname: "/contacts"
                  })
                }
                className={styles.contactUsBtn}
              >
                {t("contact.contactUs")}
              </Button>
            </Row>
          </Col>
        </Row>
        <Row
          className={styles.rowWrap}
          align={{
            xs: "top",
            sm: "middle",
            md: "middle",
            lg: "middle",
            xl: "middle"
          }}
          justify="start"
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 24, order: 2 }}
            lg={{ span: 9, order: 1 }}
            xl={{ span: 14, order: 1 }}
          >
            <img
              className={styles.mockupGadgets}
              src={mockupGadgets}
              alt={mockupGadgets}
            />
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 24, order: 1 }}
            lg={{ span: 14, order: 2 }}
            xl={{ span: 9, order: 2 }}
          >
            {" "}
            <h5 className={styles.mockupGadgetsTitle}>
              {" "}
              {t("Frontend.designTitle")}
            </h5>
            <div className={styles.mockupGadgetsText}>
              {t("Frontend.designDescription")}
            </div>
          </Col>
        </Row>
        <Row align="middle" justify="space-around">
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <div>
              <p className={styles.frontendDashboardText}>
                {t("Frontend.clientDescription")}
              </p>
              <p className={styles.frontendDashboardText}>
                {t("Frontend.visibleDescription")}
              </p>{" "}
              {size?.width && size?.width >= 768 && (
                <p className={styles.frontendDashboardText}>
                  {t("Frontend.colaborateDescription")}
                </p>
              )}
            </div>
          </Col>
          <Col xs={0} sm={0} md={0} lg={1} xl={3}></Col>
          <Col xs={20} sm={14} md={14} lg={10} xl={10}>
            <img
              className={styles.frontendDashboard}
              src={frontendDashboard}
              alt={frontendDashboard}
            />
          </Col>{" "}
          {size?.width && size?.width < 768 && (
            <Col xs={24} sm={24} md={24} lg={24} xl={9}>
              <p className={styles.frontendDashboardText}>
                {t("Frontend.colaborateDescription")}
              </p>
            </Col>
          )}
        </Row>
        <Row className={styles.lastWrapper} align="middle">
          <p>{t("Frontend.footer")}</p>
        </Row>
      </div>
    </>
  );
}
